module.exports = __webpack_public_path__ + "img/Pishro_Splash – 1.d1b4e724.png";